import React, { useEffect } from "react";
import { connect } from "react-redux";
import reportAction from "../../../store/actions/reportCampaignAction";
import constantsReportCampaign from "./constants/reportCampaign";
import ExportJsonExcel from "js-export-excel";

function ReportIPS({
  dateFrom,
  dateTo,
  browsers_ip,
  campaignIDSelected,
  getCampaignReportBrowserIP,
  getCampaignsReportBrowserIP,
  whichTypeSelect,
}) {
  useEffect(() => {
    if (Object.entries(browsers_ip).length == 0) {
      return;
    }
    let browsersIPArray = convertToArray(browsers_ip);
    let browsersIPArraySort = browsersIPArray.sort((a, b) => {
      return parseInt(b["count"]) - parseInt(a["count"]);
    });
    exportReportExcel(convertToObject(browsersIPArraySort));
  }, [browsers_ip]);

  const getExcelFileReportIP = () => {
    const dateFilterObject = {
      date_from: dateFrom,
      date_to: dateTo,
    };

    if (whichTypeSelect == constantsReportCampaign.whichTypeSelect.CAMPAIGN) {
      getCampaignReportBrowserIP({
        campaign_id: campaignIDSelected,
        ...dateFilterObject,
      });
    } else if (
      whichTypeSelect == constantsReportCampaign.whichTypeSelect.TYPE_CAMPAIGNS
    ) {
      getCampaignsReportBrowserIP({
        ...dateFilterObject,
      });
    }
  };

  const convertToObject = (browsersIPArraySort) => {
    let browsersIPObject = {};
    for (let key in browsersIPArraySort) {
      const item = browsersIPArraySort[key];
      browsersIPObject[item.ip] = item.count;
    }
    return browsersIPObject;
  };

  const exportReportExcel = (browsersIP) => {
    var option = new Object();
    option.fileName = "گزارش نمایش بر اساس IP";
    let dataExcelFile = [
      {
        one: "IP",
        two: "تعداد نمایش",
      },
    ];

    for (let key in browsersIP) {
      dataExcelFile = [
        ...dataExcelFile,
        {
          one: key,
          two: browsersIP[key],
        },
      ];
    }

    option.datas = [
      {
        sheetData: dataExcelFile,
        columnWidths: [10, 10],
      },
    ];

    const toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
    dataExcelFile = [];
  };

  const convertToArray = (browsersIP) => {
    let browsersIPArray = [];

    for (let key in browsersIP) {
      const count = browsersIP[key];
      browsersIPArray.push({
        ip: key,
        count: count,
      });
    }

    return browsersIPArray;
  };

  return (
    <div className="py-2 px-2">
      <span className="btn btn-success" onClick={getExcelFileReportIP}>
        دریافت IP های مرورگر بصورت فایل اکسل
      </span>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    browsers_ip: state.reportCampaign.browsers_ip,
    dateFrom: state.reportCampaign.date_from,
    dateTo: state.reportCampaign.date_to,
    campaignIDSelected: state.reportCampaign.campaign_id_selected,
    whichTypeSelect: state.reportCampaign.which_type_select,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCampaignReportBrowserIP: (action) => {
      dispatch({
        type: reportAction.GET_CAMPAIGN_REPORT_BROWSER_IP,
        payload: action,
      });
    },
    getCampaignsReportBrowserIP: (action) => {
      dispatch({
        type: reportAction.GET_CAMPAIGNS_REPORT_BROWSER_IP,
        payload: action,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReportIPS);
